import { Boundaries } from "@planzone/core";
import { TimeSheet, timeSheet } from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { reduceList } from "../../common/list";
import { reduceResource } from "../../common/resource";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { matchRequest } from "./utils";

const initialState: State = [];

function handleRequest(
  state: State,
  { changedRecord, filter }: Boundaries["reloadTimeSheet"]["request"],
): State {
  const index = state.findIndex((req) => matchRequest(req, filter));

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          filter,
          request: setRequestStateToPending(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          filter,
          request: setRequestStateToPending(),
          timeSheet,
        },
      ];
}

function handleSuccess(
  state: State,
  {
    changedRecord,
    filter,
    timeSheet,
  }: Boundaries["reloadTimeSheet"]["success"],
): State {
  const index = state.findIndex((req) => matchRequest(req, filter));

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          filter,
          request: setRequestStateToSuccess(),
          timeSheet,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          filter,
          request: setRequestStateToSuccess(),
          timeSheet,
        },
      ];
}

function handleFailure(
  state: State,
  { changedRecord, filter }: Boundaries["reloadTimeSheet"]["failure"],
): State {
  const index = state.findIndex((req) => matchRequest(req, filter));

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          filter,
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          filter,
          request: setRequestStateToFailure(),
          timeSheet,
        },
      ];
}

function propagateEvent(state = initialState, event: Event): State {
  return state;
}

const reduceState = createStateReducer(
  initialState,
  {
    [events.reloadTimeSheetRequested]: handleRequest,
    [events.reloadTimeSheetSucceeded]: handleSuccess,
    [events.reloadTimeSheetFailed]: handleFailure,
  },
  propagateEvent,
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
